import { ConfigProvider, App as AntdApp } from 'antd';
import enUS from 'antd/locale/en_US';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/router';

export default function App() {
  return (
    <ConfigProvider
      // 🔴 英文：填写人是组织外部的境外收款人。antd 自带的文案（下拉的 No data、
      // 清空按钮的 tooltip 等）也得跟着换，否则页面会中英混排。
      locale={enUS}
      // 移动端优先：全局默认大号控件，触屏上才够得着
      componentSize="large"
      theme={{ token: { colorPrimary: '#1677ff', borderRadius: 8 } }}
    >
      <AntdApp>
        <RouterProvider router={router} />
      </AntdApp>
    </ConfigProvider>
  );
}
